import { YearEndRxUnfinishedValueDto } from "../../../api-client";

interface ColumnNameConfig<T> {
  header: string;
  field: keyof T; 
  align?: "left" | "right" | "center";
  format?: (val: T[keyof T]) => string | number;
  csvFormat?: (val: T[keyof T]) => string; 
};

export const yearEndRxUnfinishedValuesTableConfigs = {
    yearEndRxUnfinishedValues: {
        columns: [
            { header: "Account", field: "accountName", align: "left" },
            // { header: "Jahr", field: "year", align: "center" },
            { header: "von", field: "startDate", align: "center", format: (val: string) => new Intl.DateTimeFormat('de-DE', { year: "numeric", month: "short", day: "numeric" }).format(new Date(val)) },
            { header: "bis", field: "endDate", align: "center", format: (val: string) => new Intl.DateTimeFormat('de-DE', { year: "numeric", month: "short", day: "numeric" }).format(new Date(val)) },
            { header: "Gesamtwert €", field: "rxUnfinishedValue", align: "right", format: (val: number) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(val), csvFormat: (val: number) => val.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2}) },
        ] as ColumnNameConfig<YearEndRxUnfinishedValueDto>[],
    }
}